import { render } from "./UnlockFiveDiceModal.vue?vue&type=template&id=4e616f5c&scoped=true"
import script from "./UnlockFiveDiceModal.vue?vue&type=script&lang=js"
export * from "./UnlockFiveDiceModal.vue?vue&type=script&lang=js"

import "./UnlockFiveDiceModal.vue?vue&type=style&index=0&id=4e616f5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e616f5c"]])

export default __exports__